import DataLayer from "./DataLayer";
import { getModel } from "core-web/state";
import { hashString } from "core-web/utils/hashString";

export default async (data) => {
    const product = data?.item;
    const basketId = data?.basket;
    const eventId = data?.eventId;

    if (!product || !basketId) {
        return;
    }

    const userEmail = getModel("user").email?.toLowerCase();
    const hashedEmailSHA256 = await hashString(userEmail, "SHA-256");

    DataLayer.track({
        event: "remove_from_cart",
        ecommerce: {
            basket: { id: basketId },
            remove: {
                // actionField: { list: data.list },
                products: [DataLayer.getProduct(product)],
            },
        },
        eventId,
        hashedEmailSHA256,
    });
};
